<template>
	<div class="checkout">
		<top-header></top-header>
        <div class="breadcrumb-section mb-5">
            <b-container>
                <b-row>
                    <b-col class="text-left">
                        <h5 class="mt-3 mb-3">Order Success</h5>		
                    </b-col>
                    <b-col class="text-right">
                        <h6 class="mt-3 mb-3">HOME / COMPLETE</h6>		
                    </b-col>
                </b-row>
            </b-container>
        </div>
		<b-container>
            <b-row class="mb-2">
				<b-col cols="12" class="text-center">
                    <img src="../assets/checked.svg" style="width:60px" class="pb-3">
                    <p>Thank you for your purchase!</p>
                </b-col>
            </b-row>
            <b-row class="mb-5">
				<b-col cols="12" class="text-center">
                    <b-row>
                        <b-col>
                           Your Order Id : <b-link href="/customer/dashboard">{{this.$session.get('orderplaceId')}}</b-link>
							
							
                        </b-col>
                    </b-row> 
					
                </b-col>
            </b-row>
		</b-container>
		<top-footer></top-footer>
	</div>
</template>
<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
export default {
	name: 'Checkout',
	beforeCreate: function() {
        document.body.className = 'checkout';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer
	},
	mounted(){
		
		//this.orderId=this.$root.$session.get('access_key'); 
        this.initload();
	},
	data() {
		return{
			//orderId:'',
            modal_data: {
				price: 0,
				special_price: 0
            },
            thumbnailProps: { blank: false, width: 80, height: 0, class: 'm1' },
            orderdetailurl: this.$root.WEBURL+'orderdetails',
			myWalletrecordUrl: this.$root.WEBAPI+'walletapi/mywallet-record',
			myOrderDetailsUrl: this.$root.WEBURL+'myorder-details',
		};
	},
	methods: {
        showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
            var self = this;
            self.$root.resetCart();
			/*self.axios.post(self.orderdetailurl, {
                accesskey: self.$session.get('access_key'),
                products: 1
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    //self.share_info = response.data.result.share_record;
                    //self.related_products = response.data.result.related_products;
                    //console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});*/
			/* **************Wallet Data************************** */
					
					
					self.axios.post(self.myWalletrecordUrl, {
						accesskey: self.$session.get('access_key')
					})
					.then(function (responseW) {
						if(responseW.data.error == 0 || responseW.data.error == '0'){
							var customer_info = self.$root.customer_info;
							customer_info['wallet'].blance = responseW.data.result.blance;
							customer_info['wallet'].cr_amount = responseW.data.result.cr_amount;
							customer_info['wallet'].dr_amount = responseW.data.result.dr_amount;
							customer_info['wallet'].cr_amount_cb = responseW.data.result.cr_amount_cb;
							customer_info['wallet'].dr_amount_cb = responseW.data.result.dr_amount_cb;
							customer_info['wallet'].blance_cb = responseW.data.result.blance_cb;
							customer_info['wallet'].total_blance = responseW.data.result.total_blance;
							customer_info['wallet'].expiresdate = responseW.data.result.expiresdate;
							
							self.$session.set('customer_info', customer_info);
							
						}else if(responseW.data.error == 9){
							self.$root.forceLogout(responseW.data.message);
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
					
					
					/* **************************************** */
					
					/* ========================= ECommerce Tracking ======================== */
					
					console.log('xx'+self.$session.get('orderplaceId'));
					self.axios.post(self.myOrderDetailsUrl, {
						accesskey: self.$session.get('access_key'),
						orders_id:'order_KG4x6IP17FXWVp'
					})
					.then(function (responseOrder) {
						if(responseOrder.data.error == 0 || responseOrder.data.error == '0'){
							console.log(responseOrder.data.result);
							/* var customer_info = self.$root.customer_info;
							customer_info['wallet'].blance = responseOrder.data.result.blance;
							customer_info['wallet'].cr_amount = responseW.data.result.cr_amount;
							customer_info['wallet'].dr_amount = responseW.data.result.dr_amount;
							customer_info['wallet'].cr_amount_cb = responseW.data.result.cr_amount_cb;
							customer_info['wallet'].dr_amount_cb = responseW.data.result.dr_amount_cb;
							customer_info['wallet'].blance_cb = responseW.data.result.blance_cb;
							customer_info['wallet'].total_blance = responseW.data.result.total_blance;
							customer_info['wallet'].expiresdate = responseW.data.result.expiresdate; */
							
							//self.$session.set('customer_info', customer_info);
							
						}else if(responseOrder.data.error == 9){
							self.$root.forceLogout(responseOrder.data.message);
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
					
					
					// Measures product impressions and also tracks a standard
					// pageview for the tag configuration.
					// Product impressions are sent by pushing an impressions object
					// containing one or more impressionFieldObjects.
					//var urlPost ='https://www.google-analytics.com/analytics.js';
					//var urlPost ='https://www.googletagmanager.com/gtm.js?id=GTM-PSZ3Z3B';
					//var dataLayer =[];
					
					
					
					
				
			/*
				  window.dataLayer=[];
					 window.dataLayer.push({
					 'event': 'order-success',
					  'ecommerce': {
						'purchase': {
						  'actionField': {
							'id': 'order_KYnius6Z6ZEzh3',                          // Transaction ID. Required for purchases and refunds.
							'affiliation': 'Alluraa',
							'revenue': '174.63',                     // Total transaction value (incl. tax and shipping)
							'tax':'0',
							'shipping': '45',
							'coupon': ''
						  },
						  'products': [{                            // List of productFieldObjects.
							'name': 'Nail Paint',     // Name or ID is required.
							'id': '1015',
							'price': '129.63',
							'brand': 'NewU',
							'quantity': 1,
							'coupon': ''                         // Optional fields may be omitted or set to empty string.
						   }
						   ]
						}
					  }
					});*/

					
					
					
			/* self.axios.post(urlPost, { 
				id:'GTM-PSZ3Z3B',
                data: dataLayer,
			})
			.then(function (response) {
				console.log(response);
			})
			.catch(function (error) {
				alert(error);
			}); */
 
					/* ========================= = */
					
			
			
		}
	},
	metaInfo() {
		return{
			title: 'Order Success | Alluraa',
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'Alluraa, Order Success' },
				{ name: 'description', content: 'Order Success | Alluraa' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
		
		
		
		
		
		
	}
}
</script>